import { render, staticRenderFns } from "./product-wrap-v2.modal.vue?vue&type=template&id=bcced90a&scoped=true"
import script from "./product-wrap-v2.modal.vue?vue&type=script&lang=js"
export * from "./product-wrap-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./product-wrap-v2.modal.vue?vue&type=style&index=0&id=bcced90a&prod&lang=scss&scoped=true"
import style1 from "./product-wrap-v2.modal.vue?vue&type=style&index=1&id=bcced90a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcced90a",
  null
  
)

export default component.exports